import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustSection from "../components/landing/TrustSection";
import FeaturesSection from "../components/landing/FeaturesSection";
import UseCasesSection from "../components/landing/UseCasesSection";
import TestimonialsSection from "../components/landing/TestimonialsSection";
import FinalCTASection from "../components/landing/FinalCTASection";
import Footer from "../components/Footer";
import "../styles/landing.css";

export default function LandingPage() {
  return (
    <div id="landing-top" className="yimnak-landing-page min-h-screen flex flex-col overflow-x-hidden">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <TrustSection />
        <FeaturesSection />
        <UseCasesSection />
        <TestimonialsSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
